import { getIdFromVideoUrl } from '../../utils/video/getIdFromVideoUrl'

export default function getTrainingExercisePlaylistData(entry) {
  if (!entry) return null

  const data = []
  if (entry.exercises) {
    entry.exercises.map((exercise) => {
      if (exercise.exerciseTitle && exercise.exerciseContent[0]?.videoUrl) {
        const videoId = getIdFromVideoUrl(exercise.exerciseContent[0]?.videoUrl)
        data.push({ youtubeId: videoId, youtubeTitle: exercise.exerciseTitle })
      }
      return ''
    })
  }

  if (data.length <= 0) return false

  return data
}
